import { Card, colors, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const navigate = useNavigate();
  return (
    <Stack sx={{ backgroundColor: colors.amber[200], minHeight: '100vh' }}>
      <Container maxWidth='md'>
        <Stack direction='column' m={2} alignItems='center' justifyContent='center'>
          <Card sx={{ width: '100%', height: 300 }}>
            <Stack p={10} sx={{ width: '100%', height: '100%' }} direction='column' alignItems='center' justifyContent='center'>
              <Typography variant='h3'>Thank you</Typography>
              <Typography variant='body2' sx={{ textAlign: 'center' }}>
                Your data has been saved successfully.
              </Typography>
              <Stack m={4} direction='row' spacing={1}>
                <Typography sx={{ cursor: 'pointer' }} onClick={() => navigate('/')} variant='body2'>
                  Open dashboard
                </Typography>
                <Typography variant='body2'>|</Typography>
                <Typography sx={{ cursor: 'pointer' }} onClick={() => navigate('/form')} variant='body2'>
                  Submit another submission
                </Typography>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Container>
    </Stack>
  );
};

export default SuccessPage;
